import React from 'react';

import { Grid } from '@material-ui/core';
import { GridSpacing } from '@material-ui/core/Grid';

function getSpacing(width: GridContainerWidth): GridSpacing {
  return width === 'sm' ? 2 : 3;
}

type GridContainerWidth = 'sm' | 'md';
export type GridContainerProps = {
  children: React.ReactNode;
  width?: GridContainerWidth;
  className?: string;
};

export const GridContainer = ({ children, className, width = 'sm' }: GridContainerProps) => {
  return (
    <Grid className={className} container spacing={getSpacing(width)}>
      {children}
    </Grid>
  );
};
